import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { ApplicationState } from ".";
import {
	ILayerSource,
} from "@/models/saferoads/interfaces";
import { FilterSpecification } from "maplibre-gl";

const sliceName = "legendSlice";

export type MapLegendItem = {
	legendItemId: string;
	filterValue?: string;
	label: string;
	color?: string;
	image?: string;
	enabled: boolean;
};

export type QueryableLayer = Pick<ILayerSource, "queryProperties"> & { includeInQuery: boolean };

export type MapLayer = {
	layerId: string;
	systemId: string;
	initialFilter?: FilterSpecification | undefined;
	filterAttr: string;
	legendItems: MapLegendItem[];
	minzoom?: number;
	layerAllEnabled: boolean;
	layerAnyEnabled: boolean;
} & QueryableLayer;

export interface LegendState {
	layers: MapLayer[];
}

const initialState: LegendState = {
	layers: [],
};

type SetLayerVisibilityPayload = {
	layerId: string;
	legendItemId: string;
	enabled: boolean;
};

type SetAllLegendLayerVisibilityPayload = {
	layerId: MapLayer["layerId"];
	enabled: boolean;
};

const slice = createSlice({
	name: sliceName,
	initialState,
	reducers: {
		setMapLayers: (state, { payload }: PayloadAction<MapLayer[]>) => {
			// @ts-expect-error FilterSpecification is large type, messes with store...
			state.layers = payload;
		},
		setLegendLayerVisibility: (state, { payload }: PayloadAction<SetLayerVisibilityPayload>) => {
			const layer = state.layers.find((l) => l.layerId === payload.layerId);
			if (layer) {
				const items = layer?.legendItems ?? [];
				for (const item of items) {
					if (item.legendItemId === payload.legendItemId) {
						item.enabled = payload.enabled;
					}
				}
				layer.layerAllEnabled = items?.every((item) => item.enabled === true);
				layer.layerAnyEnabled = !items?.every((item) => item.enabled === false);
			}
		},
		setAllLegendLayerVisibility: (state, { payload }: PayloadAction<SetAllLegendLayerVisibilityPayload>) => {
			const layer = state.layers.find((l) => l.layerId === payload.layerId);
			const items = layer?.legendItems ?? [];
			for (const item of items) {
				item.enabled = payload.enabled;
			}
			if (layer) {
				// if all items false: disable layer
				layer.layerAllEnabled = payload.enabled;
				layer.layerAnyEnabled = payload.enabled;
			}
		},
	},
});

// ----------------
// exports
export const selector = (state: ApplicationState): LegendState => state.legendState;
export const selectMapLayers = (state: ApplicationState): MapLayer[] => state.legendState.layers;
export const actions = {
	...slice.actions,
};
export const reducer = slice.reducer;
